import type { CSSProperties } from 'react';

import { versionLabel } from '@/version';

const badgeStyle: CSSProperties = {
  position: 'fixed',
  left: '50%',
  transform: 'translateX(-50%)',
  bottom: '2px',
  color: 'rgba(128, 128, 128, 0.45)',
  fontSize: '10px',
  lineHeight: 1.2,
  pointerEvents: 'none',
  userSelect: 'none',
  whiteSpace: 'nowrap',
  zIndex: 9999,
};

export function VersionBadge() {
  return (
    <div aria-hidden="true" style={badgeStyle}>
      {versionLabel}
    </div>
  );
}
